// extracted by mini-css-extract-plugin
export default {"container":"header_container__FdH9l","header":"header_header__iAeGt","left":"header_left__WUzO+","people":"header_people__bvVHe","right":"header_right__N9E2f"};